import React, { useState } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import TermsText from './TermsText'
import { StyledPrimaryButton } from '../../common/styledComponents/StyledButtons'
import { StyledNavigationLink } from '../../common/styledComponents/StyledLink'
import { StyledHeader2, StyledParagraph } from '../../common/styledComponents/StyledText'

import {
  StyledInnerModal,
  StyledModalWrapper
} from './styles'

const StyledModalOverlay = styled.div`
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  position: fixed;
  height: auto;
  width: auto;
  z-index: 10;
  background-color: rgba(0, 0, 0, 0.8);
  outline: none;
  display: flex;
  justify-content: center;
  align-items: center;
`

const TermsAcceptanceModal = ({ onAccept, isLoading, error }) => {
  const [isAccepted, setIsAccepted] = useState(false)
  const [showError, setShowError] = useState(false)

  const handleAcceptanceChange = (e) => {
    setIsAccepted(e.target.checked)
    if (showError) {
      setShowError(false)
    }
  }

  const handleAccept = () => {
    if (!isAccepted) {
      setShowError(true)
      return
    }
    onAccept()
  }

  const handleClose = (e) => {
    e.preventDefault()
    e.stopPropagation()
    if (!isAccepted) {
      setShowError(true)
    }
  }

  const handleOverlayClick = (e) => {
    if (!isAccepted) {
      setShowError(true)
    }
  }

  return (
    <StyledModalOverlay onClick={handleOverlayClick}>
      <StyledModalWrapper>
        <StyledInnerModal
          onClick={(e) => e.stopPropagation()}
        >
          <section style={{ padding: '20px' }} className='modal-content'>
            <StyledHeader2 style={{ textAlign: 'center', marginBottom: '20px' }}>
              Terms and Conditions Agreement Required
            </StyledHeader2>
            <StyledParagraph style={{ marginBottom: '20px', textAlign: 'center' }}>
              You must accept our Terms and Conditions to continue using the system.
            </StyledParagraph>

            <div style={{
              maxHeight: '400px',
              overflowY: 'auto',
              border: '1px solid #ddd',
              padding: '15px',
              marginBottom: '20px',
              backgroundColor: '#f9f9f9'
            }}>
              <TermsText />
            </div>

            <div style={{
              marginBottom: '20px',
              textAlign: 'center',
              padding: '10px',
              backgroundColor: '#f8f9fa',
              border: '1px solid #e9ecef',
              borderRadius: '4px'
            }}>
              <StyledParagraph style={{ marginBottom: '10px', fontSize: '14px', fontWeight: 'bold' }}>
                For your reference:
              </StyledParagraph>
              <div style={{ display: 'flex', justifyContent: 'center', gap: '20px', flexWrap: 'wrap' }}>
                <a
                  href='/terms-and-conditions'
                  target='_blank'
                  rel='noopener noreferrer'
                  style={{
                    color: '#008575',
                    textDecoration: 'none',
                    fontSize: '14px',
                    fontWeight: '500'
                  }}
                  onMouseOver={(e) => e.target.style.textDecoration = 'underline'}
                  onMouseOut={(e) => e.target.style.textDecoration = 'none'}
                >
                  📄 View Terms & Conditions
                </a>
                <a
                  href='/privacy-policy'
                  target='_blank'
                  rel='noopener noreferrer'
                  style={{
                    color: '#008575',
                    textDecoration: 'none',
                    fontSize: '14px',
                    fontWeight: '500'
                  }}
                  onMouseOver={(e) => e.target.style.textDecoration = 'underline'}
                  onMouseOut={(e) => e.target.style.textDecoration = 'none'}
                >
                  🔒 View Privacy Policy
                </a>
              </div>
            </div>

            <div style={{ marginBottom: '20px' }}>
              <label style={{
                display: 'flex',
                alignItems: 'center',
                cursor: 'pointer',
                fontSize: '16px',
                fontWeight: 'bold'
              }}>
                <input
                  type='checkbox'
                  checked={isAccepted}
                  onChange={handleAcceptanceChange}
                  style={{
                    marginRight: '10px',
                    transform: 'scale(1.2)'
                  }}
                  disabled={isLoading}
                />
                I agree to the Terms and Conditions
              </label>
            </div>

            {(showError || error) && (
              <StyledParagraph style={{
                color: '#FF8A91',
                marginBottom: '15px',
                textAlign: 'center',
                fontWeight: 'bold'
              }}>
                {showError
                  ? 'You must accept the Terms and Conditions to use the system.'
                  : error
                }
              </StyledParagraph>
            )}

            <div style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              gap: '15px'
            }}>

              <StyledPrimaryButton
                onClick={handleAccept}
                disabled={isLoading}
                style={{
                  minWidth: '150px',
                  opacity: isLoading ? 0.6 : 1,
                  cursor: isLoading ? 'not-allowed' : 'pointer'
                }}
              >
                {isLoading ? 'Processing...' : 'Accept and Continue'}
              </StyledPrimaryButton>
            </div>

            <StyledParagraph style={{
              fontSize: '12px',
              textAlign: 'center',
              marginTop: '15px',
              color: '#666'
            }}>
              This modal cannot be closed without accepting the Terms and Conditions.
            </StyledParagraph>
          </section>
        </StyledInnerModal>
      </StyledModalWrapper>
    </StyledModalOverlay>
  )
}

TermsAcceptanceModal.propTypes = {
  onAccept: PropTypes.func.isRequired,
  isLoading: PropTypes.bool,
  error: PropTypes.string
}

TermsAcceptanceModal.defaultProps = {
  isLoading: false,
  error: null
}

export default TermsAcceptanceModal
